import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "My new favourite pomodoro app",
  "description": "",
  "published": "2013-09-20T00:00:00.000Z",
  "redirect_from": ["/blog/my-new-favourite-pomodoro-app/swizec/6344"],
  "categories": "Pomodoro, Pomodoro Technique, Time management, Uncategorized",
  "hero": "./img/images-1298.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/6e2555dc1a17b7fc33ee3b30e2c5bb46/d9199/Simple-Pomodoro-Timerh5jg7a.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "66.81614349775785%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'267\\'%20viewBox=\\'0%200%20400%20267\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20134v133h401V0H0v134M376%209v3h16V5h-16v4M84%2092c-8%203-15%2012-16%2023v5h15v-3c0-12%2012-18%2020-11%202%203%203%205%203%208%200%207-3%2011-15%2019-17%2011-23%2018-25%2029v5h56v-13H86l3-3%209-8c15-10%2017-12%2020-17%205-9%204-21-3-28-6-7-20-10-31-6m149%201c-12%206-18%2024-15%2045s11%2030%2027%2030c18%201%2027-11%2028-35%200-19-3-30-11-37-7-7-20-8-29-3m63-2c-6%202-12%209-15%2017s-4%2032-1%2041c5%2013%2013%2019%2026%2019%2018%200%2027-13%2027-38%200-27-8-39-26-40l-11%201m-160%200a2512%202512%200%2001-7%2041l7%201c6%200%207%200%209-3%204-3%2010-4%2015-2%2012%207%208%2028-6%2028-5%200-10-4-11-8l-1-3h-8l-8%201c0%203%204%2011%206%2014%2011%2011%2034%2011%2044%200%2010-12%208-32-4-40-6-5-17-5-23-2l-5%203a515%20515%200%20013-17h31V91h-42m105%2012c-6%203-8%2011-8%2029%201%2018%204%2024%2013%2024s14-18%2011-38c-2-12-8-18-16-15m59%201c-5%203-6%209-6%2025l1%2018c5%2014%2019%2011%2022-3%202-9%201-29-1-34-3-7-10-10-16-6m-109%2017v8h17v-17h-17v9m0%2038v8h17v-16h-17v8m137%2089c0%205%201%207%202%208l1-3c0-3%200-3%203-3%202%200%203%201%203%203l2%203v-8c4-3-1-7-7-7h-4v7\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/6e2555dc1a17b7fc33ee3b30e2c5bb46/ca0a1/Simple-Pomodoro-Timerh5jg7a.webp 223w", "/static/6e2555dc1a17b7fc33ee3b30e2c5bb46/75680/Simple-Pomodoro-Timerh5jg7a.webp 445w", "/static/6e2555dc1a17b7fc33ee3b30e2c5bb46/8d1ba/Simple-Pomodoro-Timerh5jg7a.webp 890w", "/static/6e2555dc1a17b7fc33ee3b30e2c5bb46/e46b2/Simple-Pomodoro-Timerh5jg7a.webp 960w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/6e2555dc1a17b7fc33ee3b30e2c5bb46/e92b6/Simple-Pomodoro-Timerh5jg7a.png 223w", "/static/6e2555dc1a17b7fc33ee3b30e2c5bb46/e66bf/Simple-Pomodoro-Timerh5jg7a.png 445w", "/static/6e2555dc1a17b7fc33ee3b30e2c5bb46/4ef49/Simple-Pomodoro-Timerh5jg7a.png 890w", "/static/6e2555dc1a17b7fc33ee3b30e2c5bb46/d9199/Simple-Pomodoro-Timerh5jg7a.png 960w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/6e2555dc1a17b7fc33ee3b30e2c5bb46/4ef49/Simple-Pomodoro-Timerh5jg7a.png",
                "alt": "Simple Pomodoro Timer",
                "title": "Simple Pomodoro Timer",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Simple Pomodoro Timer`}</figcaption>{`
  `}</figure></p>
    <p>{`It's been over two years since `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/living-life-in-25min-increments/swizec/1859"
      }}>{`I started living life in 25 minute increments`}</a>{`. Since then I have done 4352 pomodoros - 1813 hours of pure focused productivity - and it's been amazing.`}</p>
    <p>{`Starting out I took Pomodoro very seriously and would do everything into 25 minute blocks with 5 minute breaks. I would stop reading articles midword if my break was over, cut off conversations midsentence and be very very annoyed when I had to pee but Pomodoro hasn't said it's break time yet.`}</p>
    <p>{`I even did dishes and sweeping the floor in a pomodoro block.`}</p>
    <p>{`These days I'm more relaxed about it. Sometimes, when I'm writing, I even work off the clock and don't turn the timer on. It's usually a mistake because I get dragged onto the internet, but at least I don't break my writing flow once I do actually get into it.`}</p>
    <p>{`All this time I've been using the first Pomodoro app I downloaded. Partly because it was the only real option at the time, partly because it was good enough and I didn't care to check for others.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "640px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/02b58b57297c653381ec17aa355fba86/6af66/images-1298.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "150.2242152466368%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'600\\'%20viewBox=\\'0%200%20400%20600\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%2018v17h401V0H0v18m364-5v4h24V8h-24v5M15%2062c-2%201-2%203-2%209%200%207%201%208%203%208s2%200%202-3c0-2%200-3%202-3%204%200%207-8%203-11-2-2-6-2-8%200m14-1c-2%201-3%2015-1%2017s8%201%209-1c3-2%203-13%200-15-2-2-6-2-8-1m13%200l-1%2010c0%208%200%208%203%208%202%200%202%200%202-8%200-5%200-8%201-7l1%208c0%206%200%207%202%207s2-1%202-6l1-8c1-4%202-1%202%207%200%207%200%207%203%207%202%200%202%200%202-7%200-10-1-12-10-12l-8%201m21%201c-3%202-3%2013%200%2015%202%202%206%202%208%201%203-1%203-16%200-17s-7-1-8%201m12%207l1%2010h4c6%200%207-1%207-9s-2-10-8-10h-4v9m16-8c-2%201-2%203-2%209%200%207%201%208%203%208%206%202%208%200%209-7%200-9-5-14-10-10m14%200c-3%202-3%2018%200%2018%202%200%202-1%202-3%200-3%200-4%202-4l1%204c0%202%200%203%202%203s3-3%202-6v-6c0-6-4-9-9-6m13%200c-2%202-2%2014%200%2016%201%202%207%203%209%201s1-14-1-16-5-2-8-1m61%205c-3%204-2%209%202%2010%202%201%206%205%205%207l-12%202c-23%203-32%206-45%2017a81%2081%200%2000-30%2061c-1%2023%203%2034%2019%2057l3%203-3%208c-4%2010-4%2012%205%2015a926%20926%200%200118%209c5%203%2015%206%2023%207l13%202c22%204%2070%201%20102-5%2013-3%2014-9%205-27l-5-10%202-3c3-5%2010-18%2010-21%201-2%201-2-8%202a248%20248%200%2001-175-6l-4-2v-6l1-15c0-8%200-9%202-9l2%201h10l-4-2-3-2%201-6c4-14%2010-25%2019-35%205-5%206-6%2010-6%205%200%205%201%202%204-4%204-12%2019-11%2021l5-4c5-5%2019-15%2021-15s1%205-7%2017l-9%2019-5%208-4%203c0%201%201%201%202-1%203-3%207-3%2011%201s3%206-3%207c-6%200-7%200-5%202l5%201%206-1-3%203c-3%202-4%202-7%202h-4c0%202-5%206-7%206-4%200-13-3-14-4-4-4-6-4-6%200l-2%204c-2%200-3%205-1%206%201%201%201%200%201-2l1-3%201%204%201%203%201-3c0-2%200-3%201-2l1%203c0%204%202%204%202%200%201-2%201-2%202%201%201%204%203%205%203%201%200-2%200-3%201-2l1%203c0%202%201%203%202%203%202%201%202%200%202-5%200-4%200-5%202-5l1%207%201%206%202%201c1%200%202-1%202-3l1-3v3c0%203%200%204%202%204%204%201%204%201%204-2l1-4%201%204c0%203%201%204%202%204%203%202%204%201%204-3l1-4v4c0%204%200%205%203%205%203%201%203%201%203-3%200-5%202-5%202%200%200%204%201%205%203%205%203%200%203%200%203-5l1-6%201%206v6h3c3%200%203%200%203-2l1-3%201%203c0%203%200%203%203%203s3%200%203-3l1-3v3c0%202%201%203%202%203%204%201%204%201%204-2l1-4%201%204c0%203%200%203%203%203s3%200%203-4l1-3v3c0%204%200%204%203%204s3%200%203-5%200-6%202-6l1%206c0%205%200%205%203%205s3%200%203-4l1-4%201%204c0%204%200%204%203%204%202%200%203-1%203-5l1-4v4c0%204%200%204%203%204s3%200%203-4v-4l1%204c0%203%201%204%203%204s3-1%203-4l1-4v3c0%204%200%204%203%204%202%200%203-1%203-6%200-7%202-8%203-1v5c1%202%2030-6%2043-11%209-3%209-4%2011-23%203-29-8-55-30-75l-9-8c-1-2-9-5-18-8-10-2-19-3-35%200-3%200-4%200-7-5-9-15-14-17-19-11m15%2094c1%201%200%202-1%203v2l1%205c0%207%201%208%204%208s4-2%202-3-1-9%200-10v-2c-1-1-2-2-1-3%200-2%200-2-2-2-3%200-3%200-3%202m53%200c1%201%200%202-1%203v2l1%205%201%206c1%202%206%203%206%201l-1-2v-12l-1-3c0-2-1-2-3-2s-2%200-2%202m-93%203c-4%204-3%207%203%209l4%202c0%202-3%202-5%201-2-2-5-2-5-1%200%205%209%206%2013%203%203-4%201-7-4-8l-4-3h9c0-3-8-5-11-3m16%201c-4%204-2%206%204%208l4%202c-1%202-4%202-5%201-2-2-5-2-5-1%200%204%208%206%2011%204%205-3%204-8-3-10-4-1-4-2-1-3l2%201%203%201c3%200%203-1%200-3-3-3-8-2-10%200m35%201c-5%206-1%2013%206%2013%205%200%208-2%208-7s-3-9-8-9c-3%200-4%201-6%203m27-1c-4%204-2%206%204%208l4%202c-1%202-4%202-5%201-2-3-5-2-5%200%201%206%2014%204%2014-1%200-3-1-5-6-6l-3-1c0-2%203-2%204-1l3%201h3l-3-3c-3-3-7-3-10%200m26%200c-2%202-2%203-1%203l5-1h3c2%201%200%203-4%203-2%200-5%202-5%205s2%204%205%204h10l-1-7c-1-8-1-8-6-9-3%200-4%200-6%202M0%20423v132h22l2%204c2%204%203%205%202%208%200%204%200%204%203%205%209%204%2028%205%2041%202%208-2%208-2%206-7-1-4-1-4%201-7l1-4%20128-1h129v-11c1-15%201-15%2024-15h18l3%203c3%203%204%203%204%2013v10h17V291H0v132m93-114c0%202%200%203-2%202-5-1-8%207-4%2010l5%202h3v-8l-1-8-1%202m76%200c0%202%200%203-2%202-2%200-3%200-4%202-4%205-1%2010%205%2010h3v-8l-1-8-1%202m83%200v12c3%205%209%201%209-6%200-6-5-10-9-6m-220%203c-1%201%200%2015%201%2015l1-3c0-2%200-2%202-1l5-1v-10h-9m13%201c-3%202-2%206%200%208%204%205%2011-1%208-7-2-3-6-4-8-1m30%200c-3%202-2%206%200%208%204%205%2011-1%208-7-2-3-6-4-8-1m23%200c-3%203-2%206%200%208%204%205%2011-1%208-7-2-3-6-4-8-1m19-1l-1%205c0%206%205%208%208%204%205-5-2-14-7-9m34%201c-3%204-1%2010%204%2010%204%200%207-7%203-10-2-3-6-2-7%200m-58%2033c0%202%200%202-2%202-2-1-6%202-6%205%200%204%202%206%206%206h4v-8l-1-8-1%203m-61%202c-1%201%200%2015%201%2015s2-1%201-2c0-2%200-2%203-2%204%200%205-2%205-6%200-3-1-4-2-5h-8m13%201c-4%204-2%2010%203%2010%203%200%205-2%205-6%200-5-4-8-8-4m30%200c-4%204-2%2010%203%2010%203%200%205-2%205-6%200-5-4-8-8-4m23%200c-4%204-2%2010%204%2010%202%200%205-3%205-6%200-2-3-6-5-6l-4%202m20%200c-2%201-3%207-1%209s7%201%208-1c3-6-3-13-7-8m28%200c-2%202-3%207-1%209s7%201%208-1c3-6-3-13-7-8m24%2045h-11v20h20v-9c0-6%200-9%202-10v-2l-11%201m-10%2010v8h17v-13l-3%204-4%204c0%202-3%200-6-3-3-5-3-6%201-4%202%202%203%202%207-2l4-3h-16v9m195-7c0%202%200%203-3%202-3%200-5%202-5%206s2%205%206%205h4v-8l-1-7-1%202m-196%2048v10h20v-9l1-10c1-1-1-1-10-1h-11v10m1%200v9h17v-14l-2%203c-7%208-6%208-11%201-3-4-3-5%201-2%203%201%203%201%207-2l4-4h-16v9m77-8c0%203%204%2014%205%2014l3-6%201-5%202%205c2%208%204%207%206-1l2-8c-1-1-3%201-3%205-2%206-3%206-4%201-2-7-4-8-5-2-2%209-2%209-4-1-1-3-3-4-3-2m-78%2049v10h20v-20h-20v10m1%201v8h17v-17h-17v9m166-4l-2%204c0%206%207%208%2010%203%203-6-5-12-8-7M30%20532c-3%204-5%208-5%2014%200%205%201%206%205%206l3-5%204-10c3-5%203-6-1-4-3%203-4%201-1-1l3-2h-3l-5%202m312%200c-3%201-4%206-4%2020%200%2021%200%2021%2021%2021h16l3-3%203-3v-31l-3-2-3-3h-16l-17%201m14%206c-2%201-2%201%200%202v2c-3%201-2%202%202%202h4l-4%201c-7%201-9%203-12%208l-3%204%202%202%202%204c0%204%201%204%205-1%204-6%207-8%2013-9%205%200%206-1%206-2l1-2c6%200%205-4-2-8s-10-4-14-3m-175%2027l2%205%201%204%201-3c2-3%202-3%202-1%201%203%203%203%204-1%200-4%201-4%203%201l2%204%201-3c1-3%201-3%202-2%201%204%201%205%202%202l2-7-2%203-1%202v-2l-2-3-2%203-1%202v-2c-1-4-5-4-5-1l-1%203v-3l-3-2-1%202v3l-2-3-2-1\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/02b58b57297c653381ec17aa355fba86/ca0a1/images-1298.webp 223w", "/static/02b58b57297c653381ec17aa355fba86/75680/images-1298.webp 445w", "/static/02b58b57297c653381ec17aa355fba86/0ba47/images-1298.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/02b58b57297c653381ec17aa355fba86/e92b6/images-1298.png 223w", "/static/02b58b57297c653381ec17aa355fba86/e66bf/images-1298.png 445w", "/static/02b58b57297c653381ec17aa355fba86/6af66/images-1298.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/02b58b57297c653381ec17aa355fba86/6af66/images-1298.png",
                "alt": "My old pomodoro timer",
                "title": "My old pomodoro timer",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`My old pomodoro timer`}</figcaption>{`
  `}</figure></p>
    <p>{`Just like a real timer. It ticks, it looks like a tomato. The ticking gave a cadence to my work and the tomatoness ... well it's kinda neat.`}</p>
    <p>{`But it was time for a change. Something simpler to go with the simplified iOS7.`}</p>
    <p><a parentName="p" {...{
        "href": "https://itunes.apple.com/us/app/simple-pomodoro-timer/id496191025?mt=8"
      }}>{`Simple Pomodoro Timer`}</a>{` by SourcePad.`}</p>
    <p>{`It's a timer. It counts down 25 minutes. Then it counts down a break. Then it tells you break is over. That's it.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/56f5620ddb2e9b68620219d97eb7f4ac/d9199/images-1300.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "66.81614349775785%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'267\\'%20viewBox=\\'0%200%20400%20267\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%209v8h401V0H0v9m376-1c-1%204-1%204%208%204h8V5h-16v3m-15%2032l-5%202c-4%201-4%207%200%207l5%202c3%203%203%202%203-6v-7l-3%202M71%20129v34h19c17-1%2020-1%2024-3%2012-5%2017-14%2018-30%200-17-4-26-15-32l-5-3-21-1H71v35m243-26c0%207%202%2030%204%2037%200%202%201%202%204%202l3-1a774%20774%200%20014-39v-8h-15v9m-227%203v44h9c12-1%2015-2%2019-10%205-10%201-27-7-31-3-2-20-4-21-3m71%206c-12%204-18%2012-17%2026%200%209%201%2013%206%2018%2011%2013%2035%209%2042-5%2010-23-8-45-31-39m65%200l-6%204-3%203v-6h-13v50h13v-16c1-18%202-22%206-24s10-1%2012%203c1%202%202%205%202%2020v17h14l-1-19c0-22-1-27-7-30-4-2-13-3-17-2m49%201c-25%209-21%2048%205%2051%2012%201%2023-5%2026-15%202-4-9-3-13%201-3%203-7%204-12%203-3%200-8-4-8-6l-1-4v-2h36v-4c0-18-16-30-33-24m-113%2011c-9%207-6%2027%204%2029%209%203%2016-6%2014-19-1-10-11-16-18-10m114%201c-2%201-3%204-3%205-1%202-1%202%2010%202%2012%200%2012%200%209-5-3-6-11-7-16-2m41%2031v7h15v-15h-15v8M73%20212v8h4c6-1%208-4%206-8-2-3-3-3-5-3-2%201-2%200-2-2l-1-2c-2%200-2%201-2%207m-40%203c0%207%203%207%203%201%200-3%201-4%202-4l1%204c0%205%203%206%203%200%200-2%201-3%202-3s2%201%202%203c0%206%203%205%203%200%200-6-1-7-9-7h-7v6m38%2033v8h4c4%200%205-1%206-3%202-4-1-8-5-8-2%201-2%200-2-2l-1-2c-2%200-2%201-2%207m185%200l1%208h3c7%200%2011-4%207-8v-1c3-2-1-6-7-6h-4v7m-201-1c-4%203-1%209%203%208h3l-4%201c-3%200-4%202-1%203%205%202%208-1%208-9v-5h-4l-5%202m292%204c0%207%203%207%203%201%201-5%202-5%203%200s3%205%203%201%202-7%203-5l1%204c0%203%200%204%202%204%201%200%202-8%200-10l-8-1h-7v6\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/56f5620ddb2e9b68620219d97eb7f4ac/ca0a1/images-1300.webp 223w", "/static/56f5620ddb2e9b68620219d97eb7f4ac/75680/images-1300.webp 445w", "/static/56f5620ddb2e9b68620219d97eb7f4ac/8d1ba/images-1300.webp 890w", "/static/56f5620ddb2e9b68620219d97eb7f4ac/e46b2/images-1300.webp 960w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/56f5620ddb2e9b68620219d97eb7f4ac/e92b6/images-1300.png 223w", "/static/56f5620ddb2e9b68620219d97eb7f4ac/e66bf/images-1300.png 445w", "/static/56f5620ddb2e9b68620219d97eb7f4ac/4ef49/images-1300.png 890w", "/static/56f5620ddb2e9b68620219d97eb7f4ac/d9199/images-1300.png 960w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/56f5620ddb2e9b68620219d97eb7f4ac/4ef49/images-1300.png",
                "alt": "Done!",
                "title": "Done!",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Done!`}</figcaption>{`
  `}</figure></p>
    <p>{`It doesn't mandate anything. After every pomodoro you can opt for a short break (5min) or a long break (20min). The old timer was more like a hover mum `}<em parentName="p">{`"Oh you haven't done four pomodoros yet in this session have you! No long break for you!"`}</em></p>
    <p>{`And it's quiet!`}</p>
    <p>{`While I might like the ticking, people working in the same room always found it obnoxious. If you do turn on the sound the timer will ding when it's done.`}</p>
    <p>{`Which sounds exactly the same as my IRC notifications. It gets confusing.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/aef0906818ae8da053ebf6b20019bb63/d9199/images-1301.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "66.81614349775785%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'267\\'%20viewBox=\\'0%200%20400%20267\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%209v8h401V0H0v9m376%200v3h16V5h-16v4m-15%2031l-5%202c-2%200-2%201-2%204%200%202%200%203%202%203l5%202c3%203%203%202%203-6v-7l-3%202M83%2092c-12%205-18%2020-17%2041%202%2024%2011%2035%2028%2035%2019%200%2029-15%2028-43-1-16-5-26-14-32-6-3-19-4-25-1m59%2021l-16%2022v15h32v17h15v-17h10v-13h-10V91h-14l-17%2022m85-22l-4%2021-4%2021h7c6%200%207%200%2010-2%2011-10%2026%201%2021%2015-4%2012-20%2013-23%202l-1-3h-16v4c4%2021%2038%2027%2051%208%208-12%206-29-4-37-8-6-19-6-26-1l-3%202v-3l2-8%201-6h31V91h-42m53%208v7h35l-5%208c-10%2015-17%2031-19%2048l-1%205h17v-7c2-18%2011-40%2020-50%205-6%205-6%205-12v-7h-52v8m-190%204c-6%203-8%2010-8%2028%200%2013%201%2015%203%2019%205%208%2014%208%2018%200%203-6%204-29%202-37-3-8-9-12-15-10m58%2020l-9%2013%2010%201h9v-26l-10%2012m43-2v8h17v-17h-17v9m1%2030l-1%208v8h17v-17h-8l-8%201m149%2092c0%202%200%203-2%202-3%200-6%202-6%205%200%204%203%206%207%206l4-1v-7l-1-7-2%202m-31%208c0%207%203%207%203%201%201-5%202-5%203%200%201%204%203%205%203%201l1-5c1-2%203%200%203%204%200%205%202%205%203%200%200-6-1-7-9-7h-7v6\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/aef0906818ae8da053ebf6b20019bb63/ca0a1/images-1301.webp 223w", "/static/aef0906818ae8da053ebf6b20019bb63/75680/images-1301.webp 445w", "/static/aef0906818ae8da053ebf6b20019bb63/8d1ba/images-1301.webp 890w", "/static/aef0906818ae8da053ebf6b20019bb63/e46b2/images-1301.webp 960w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/aef0906818ae8da053ebf6b20019bb63/e92b6/images-1301.png 223w", "/static/aef0906818ae8da053ebf6b20019bb63/e66bf/images-1301.png 445w", "/static/aef0906818ae8da053ebf6b20019bb63/4ef49/images-1301.png 890w", "/static/aef0906818ae8da053ebf6b20019bb63/d9199/images-1301.png 960w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/aef0906818ae8da053ebf6b20019bb63/4ef49/images-1301.png",
                "alt": "Break timer",
                "title": "Break timer",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Break timer`}</figcaption>{`
  `}</figure></p>
    <p>{`One of the best features is that it takes up the whole screen. You can see what you're supposed to be doing at a glance. Black screen == work time. White screen == break time.`}</p>
    <p>{`The old one used less than half the screen for this feedback - red or green tomato - and you had to squint at the timer to see the numbers.`}</p>
    <p>{`The only thing I don't like about the new timer is that there is too much clicking. Work done, click for a break. Break done, click to go to timer, then click to start the clock. Sometimes you forget and suddenly it's been a ten minute break or you've been working for forty minutes straight.`}</p>
    <p>{`But it's super encouraging!`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/7176cb2c0e9d0d306eec1e0a76651dda/d9199/images-1302.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "66.81614349775785%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'267\\'%20viewBox=\\'0%200%20400%20267\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%209v8h401V0H0v9m375%200v3h17V5h-17v4m-14%2031l-5%202c-4%201-4%207%200%207l5%202c3%203%203%202%203-6v-7l-3%202M82%20127l1%2013h8c7%200%209-1%2011-2%203-3%203-8%200-11-2-1-2-2-1-3%203-2%202-6%200-8s-3-2-11-2h-8v13m67%200l1%2013h2c3%200%203%200%203-3%200-5%202-6%204-1%203%203%204%204%206%204%203%200%203%200-1-7-4-5-4-5%200-9l3-3h-3l-6%203-3%203v-13h-6v13m142%200v13h2c3%200%203-1%203-4%201-5%202-5%205%200%202%203%203%204%205%204%204%200%204%200-1-7l-3-5%203-4%203-3h-3c-2%200-4%201-5%203-4%204-4%204-4-3s0-7-2-7h-3v13m-110-9c0%202%200%203-2%203l-1%202%202%201%201%206c0%208%201%2010%206%2010%202%200%203%200%203-2l-1-2c-2%200-3-3-3-8%200-3%201-3%202-3%203%200%203-4%200-4l-2-3c0-3%200-3-2-3-3%200-3%200-3%203m-68%203c-3%201-6%203-6%205s5%201%206-1c2-2%205-1%206%201l-4%203c-7%201-8%202-8%205%200%205%201%206%2010%206h8l-1-8-1-10c-2-1-7-2-10-1m20%200c-9%205-6%2019%204%2019%206%200%2012-6%207-7-1-1-2%200-3%201-3%204-8%201-8-4%201-5%204-7%207-4%202%202%206%203%206%201s-4-6-6-6h-7m66%200c-6%201-9%2012-4%2017%206%204%2013%202%2016-4%203-8-3-15-12-13m61%200c-4%201-6%204-6%209%200%206%203%2010%2010%2010%206%200%209-3%209-9%200-8-5-12-13-10m25%201h-4l-3-1-1%2010v9h2c3%200%203%200%203-6s2-9%205-9l2-2c0-3-1-3-4-1m-62%200c6%2018%206%2018%209%2018%202%200%203-1%204-6l2-6%201%206c4%2011%208%207%2012-10%201-3%201-3-2-3-2%200-3%201-4%207l-1%206-2-5-2-7-2-1c-3%200-3%201-4%206l-2%205-2-5c-1-6-1-6-4-6l-3%201m33%20126l1%208h3c7%200%2011-4%207-8v-1c3-2-1-6-7-6h-4v7m91%203c0%206%203%207%203%201%201-6%203-6%203-1%201%205%203%207%203%202l1-5c1-2%203%200%203%204%200%203%200%204%202%204%201%200%202-8%200-10l-8-1h-7v6\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/7176cb2c0e9d0d306eec1e0a76651dda/ca0a1/images-1302.webp 223w", "/static/7176cb2c0e9d0d306eec1e0a76651dda/75680/images-1302.webp 445w", "/static/7176cb2c0e9d0d306eec1e0a76651dda/8d1ba/images-1302.webp 890w", "/static/7176cb2c0e9d0d306eec1e0a76651dda/e46b2/images-1302.webp 960w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/7176cb2c0e9d0d306eec1e0a76651dda/e92b6/images-1302.png 223w", "/static/7176cb2c0e9d0d306eec1e0a76651dda/e66bf/images-1302.png 445w", "/static/7176cb2c0e9d0d306eec1e0a76651dda/4ef49/images-1302.png 890w", "/static/7176cb2c0e9d0d306eec1e0a76651dda/d9199/images-1302.png 960w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/7176cb2c0e9d0d306eec1e0a76651dda/4ef49/images-1302.png",
                "alt": "Back to work!",
                "title": "Back to work!",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Back to work!`}</figcaption>{`
  `}</figure></p>
    <p>{`Green means go! Work, right now. Do it. You know you want to!`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=deaf5cf6-8886-4020-8eba-6923e3202da0",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      